import Card from '@ui/Card';
import Skeleton from '@ui/Skeleton';
import Typography from '@ui/Typography';
import React from 'react';

function SmallCardedSkeleton(props) {
  const { title, variant = 'elevated' } = props;
  return (
    <Card variant={variant}>
      <Typography variant="h3" className="mb-6">
        {title}
      </Typography>
      <div className="flex flex-col gap-6">
        {Array(3)
          .fill(0)
          .map((_, index) => (
            <div key={index} className="flex flex-col gap-3">
              <div className="flex gap-4">
                <Skeleton variant="circle" className="h-10 w-10" />
                <div className="flex flex-1 flex-col justify-between">
                  <Skeleton variant="rect" className="h-5" />
                  <Skeleton variant="rect" className="h-3" />
                </div>
              </div>
              <div className="flex flex-1 flex-col gap-2">
                <Skeleton variant="rect" className="h-4 w-3/4" />
                <Skeleton variant="rect" className="h-3" />
              </div>
            </div>
          ))}
      </div>
    </Card>
  );
}

export default SmallCardedSkeleton;
